
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/service/page/[id]",
      function () {
        return require("private-next-pages/cases/service/page/[id].tsx");
      }
    ]);
  